import styled from 'styled-components';
import { AlphaTheme } from '../../../design-system/ThemeProvider/alphaTheme';

export const ResultsCountWrapper = styled.section`
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.foregroundNeutral100 ?? 'inherit'};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding-top: 48px;
`;
